import * as tf from "@tensorflow/tfjs";
import { computePOS } from "./pos";
import { normalizeRGB } from "./signalUtils";

const WINDOW = 256;

export function createRppgCollector(model, onSignal) {

  let rgb = [];

  const collector = async function (rgbIn) {

    try {

      rgb.push(rgbIn);

      if (rgb.length < WINDOW) return;
      if (rgb.length > WINDOW) rgb.shift();

      console.log("🟢 RGB Buffer Length:", rgb.length);

      const norm = normalizeRGB(rgb);
      const pos = computePOS(norm);

      if (!pos || pos.length !== WINDOW) {
        console.log("❌ POS length issue:", pos?.length);
        return;
      }

      console.log("🟢 POS Length:", pos.length);

      // 🔥 CREATE tensor normally (no async inside tidy)
      const input = tf.tensor(pos, [1, WINDOW, 1]);
      console.log("🟢 Tensor Shape:", input.shape);

      const output = model.predict(input);

      const data = await output.data();   // ✅ await outside tidy
      const rppg = Array.from(data);

      console.log("🟢 Model Output Length:", rppg.length);

      const latestValue = rppg[rppg.length - 1];
      onSignal(latestValue);

      // 🔥 MANUAL CLEANUP
      input.dispose();
      output.dispose();

    } catch (err) {
      console.error("rPPG Collector Error:", err);
    }
  };

  collector.getRGBLength = () => rgb.length;

  return collector;
}
